/**
 * 全局混入，注意使用！ 一旦使用全局混入对象，将会影响到所有之后创建的Vue实例。
 */
import { getParamString } from '@/commons/utils';
export default {
    methods: {
        exortExc (res, name, fileType = '.xlsx') {
            const blob = new Blob([res.data], {
                type: 'application/msexcel'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            let fileName = name + fileType;
            if (!res.headers) {
                const contentDisposition = res.headers['content-disposition'];
                const fileNameMatch = contentDisposition.split('filename=');
                if (fileNameMatch.length === 2) {
                    let temp = fileNameMatch[1].replace(new RegExp('\\+', 'gm'), '%20');
                    fileName = decodeURIComponent(temp);
                }
            }
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }
    },
    mounted () {
        if (!window.localStorage.getItem('token')) {
            window.localStorage.setItem('token', getParamString('token'));
        }
        if (!window.localStorage.getItem('tokenType')) {
            window.localStorage.setItem('tokenType', getParamString('tokenType'));
        }
    },
    created () {

    }
};
